import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const SideNav = () => {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const toggleDrawer = () => {
        setOpen(!open);
    };

    const handleNavigation = (path) => {
        navigate(path);
        setOpen(false);
    };

    return (
        <Box>
            <IconButton onClick={toggleDrawer} sx={{ position: 'fixed', top: 16, left: 16, color: 'white' }}>
                <MenuIcon />
            </IconButton>

            <Drawer anchor="left" open={open} onClose={toggleDrawer}>
                <Box
                    sx={{
                        width: 250,
                        backgroundColor: '#1E1E1E',
                        height: '100%',
                        color: 'white',
                        paddingTop: 2,
                    }}
                >
                    <Typography variant="h6" sx={{ textAlign: 'center', paddingY: 2 }}>
                        Navigation
                    </Typography>
                    <Divider sx={{ backgroundColor: '#37474F' }} />

                    <List>
                        <ListItem button onClick={() => handleNavigation('/')}>
                            <ListItemText primary="Home" />
                        </ListItem>
                        <ListItem button onClick={() => handleNavigation('/projects')}>
                            <ListItemText primary="Projects" />
                        </ListItem>
                        <ListItem button onClick={() => handleNavigation('/about')}>
                            <ListItemText primary="About Me" />
                        </ListItem>
                        <ListItem button onClick={() => handleNavigation('/contact')}>
                            <ListItemText primary="Contact" />
                        </ListItem>
                        <ListItem button onClick={() => handleNavigation('/wildside')}>
                            <ListItemText primary="Wild Side" />
                        </ListItem>
                    </List>
                </Box>
            </Drawer>
        </Box>
    );
};

export default SideNav;